import React, { Fragment } from "react";
import { BarChartLoading, TableBox } from "@/components";
import { bool, string, object } from "prop-types";
import { Container, Typography, useTheme } from "@mui/material";
import { BarChart } from "../D3Charts";

interface SeriesItem {
  dataKey: string;
  label: string;
  color: string;
  unit?: string;
}

interface BarChartBoxProps {
  title?: string;
  data?: {
    dataset: Array<{ label: string; [key: string]: any }>;
    series: SeriesItem[];
  };
  dataKey?: string;
  loading?: boolean;
  chartId?: string;
}

export const BarChartBox = (props: BarChartBoxProps) => {
  // const chartSetting = BarChartSettings;
  const theme = useTheme();

  const propsDefault = {
    title: "",
    data: {
      dataset: [] as Array<{ label: string; [key: string]: any }>,
      // xDataKey: "",
      // yLabel: "",
      series: [
        {
          dataKey: "",
          label: "",
          color: "",
        },
      ] as SeriesItem[],
    },
    dataKey: "",
    loading: false,
  };

  // Use props directly with fallbacks to avoid state management
  const title = props.title || propsDefault.title;
  const data = props.data || propsDefault.data;
  const loading = props.loading ?? propsDefault.loading;

  return (
    <TableBox
      sx={{
        minHeight: "350px",
        padding: "24px",
        position: "relative",
      }}
    >
      <Typography variant="h4">{title}</Typography>
      <Container
        sx={{
          position: "absolute",
          top: 25,
          right: 25,
          display: "flex",
          justifyContent: "flex-end",
          // width: 200,
          alignItems: "center",
          gap: 2,
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        {data?.series?.map((obj: SeriesItem, index: number) => {
          return (
            <Fragment key={`span-${index}`}>
              <span
                style={{
                  height: 12,
                  width: 12,
                  backgroundColor: obj.color,
                  borderRadius: "100%",
                }}
              />
              <Typography
                sx={{
                  textTransform: "capitalize",
                }}
                component="p"
              >
                {obj.label}
              </Typography>
            </Fragment>
          );
        })}
      </Container>
      {loading && (!data?.dataset || data.dataset.length === 0) ? (
        <BarChartLoading />
      ) : (
        // <BarChart
        //   dataset={data.dataset}
        //   xAxis={[{
        //     scaleType: "band",
        //     dataKey: data.xDataKey
        //   }]}
        //   yAxis={[
        //     {
        //       label: data.yLabel
        //     }
        //   ]}
        //   series={data.series}
        //   slotProps={{
        //     // legend: {
        //     //   direction: "row",
        //     //   position: {
        //     //     vertical: "top",
        //     //     horizontal: "left"
        //     //   },
        //     //   padding: 0
        //     // }
        //   }}
        //   {...chartSetting}
        // />
        <BarChart
          {...props}
          // prefix={props.energyType && Constants[props.energyType].prefixes[props.dataKey]}
          // color={props.energyType && Constants[props.energyType].color}
          color={
            data?.series?.[0]?.color
              ? data.series[0].color
              : theme.palette.primary.main
          }
          // data={data?.dataset}
          height={250}
          // dataKey={props.dataKey}
        />
      )}
    </TableBox>
  );
};

BarChartBox.propTypes = {
  loading: bool,
  title: string,
  data: object,
  // data: PropTypes.objectOf({
  //   dataset: arrayOf(object),
  //   xDataKey: string,
  //   yLabel: string,
  //   series: arrayOf({
  //     dataKey: string,
  //     label: string,
  //     color: string
  //   })
  // })
};
